<template>
  <v-container fluid>
    <v-card>
      <v-row class="pt-2 pl-4">
        <h3>一、搜尋單一藥品：請輸入醫令名、藥名、學名/商品名</h3>
      </v-row>
      <v-row dense no-gutters>
        <v-text-field
          v-model="search"
          v-show="false"
          class="px-4 mb-3"
          height="20px"
          hide-details
          clearable
        ></v-text-field>

        <v-autocomplete
          v-model="drug"
          :items="drugs"
          :item-value="setValue"
          :filter="customFilter"
          item-text="DrugCode"
          class="pt-3"
          color="primary"
          clearable
          hide-details
          rounded
          solo
          dense
        >
          <template #item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title
                  >醫令名【{{ data.item.DrugCode }}】 — 藥名【{{
                    data.item.DrugName
                  }}】學名【{{ data.item.DrugName2 }}】</v-list-item-title
                >
                <v-list-item-subtitle>
                  {{ data.item.CtrName }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-row>

      <div class="mb-6"></div>
      <v-divider></v-divider>

      <v-row class="pt-2 pl-4">
        <h3>二、搜尋院所藥品明細：請勾選院所，將呈現院所「全部藥品項」</h3>
      </v-row>
      <v-row dense no-gutters>
        <v-col
          v-for="(Ctr, index) in deps"
          :key="deps[index].DepCode"
          cols="12"
          sm="4"
          md="4"
        >
          <v-checkbox
            v-model="depSelect"
            :label="Ctr.DepNameWeb"
            :value="Ctr.DepCode"
            hide-details
            multiple
            dense
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card>

    <div class="mb-6"></div>

    <v-row class="pt-2 pl-4"></v-row>
    <v-row dense no-gutters>
      <v-card width="100%">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :footer-props="footerprops"
          :items-per-page="-1"
          height="50vh"
          fixed-header
          dense
        >
          <template #no-data>
            <v-alert class="mt-2" dense outlined type="info"
              >查無建檔記錄</v-alert
            >
          </template>
          <template #no-results>
            <v-alert class="mt-2" dense outlined type="info"
              >查無建檔記錄</v-alert
            >
          </template>
        </v-data-table>
      </v-card>
    </v-row>

    <v-overlay v-model="loading" class="text-center">
      <p>讀取中......</p>
      <v-progress-circular size="50" indeterminate />
    </v-overlay>
  </v-container>
</template>

<script>
import api from "../utils/apis/AdMedicalApi.js";

export default {
  data: () => ({
    loading: false,
    deps: [],
    depSelect: [],
    search: "",
    fliters: {
      drug: "",
    },
    drug: undefined,
    drugs: [],
    items: [],
    headers: [
      // {
      //   text: "NO",
      //   value: "SerialNumber",
      //   class: "text-h7 font-weight-bold lime accent-1",
      // },
      {
        text: "院所",
        value: "CtrName",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "嘉基代碼",
        value: "DrugCode",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "健保碼",
        value: "PrsInsId",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "藥品名稱",
        value: "DrugName",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "學名",
        value: "DrugName2",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "單位",
        value: "DrugUnit",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "自費價",
        value: "DrugOwnUpc",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "健保價",
        value: "DrugInsUpc",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "廠商",
        value: "VdrTitle",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "100px",
      },
      {
        text: "外觀",
        value: "DrugOutside",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "150px",
      },
      {
        text: "警語",
        value: "DrugWarning",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "200px",
      },
      {
        text: "適應症",
        value: "DrugSuit",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "200px",
      },
      {
        text: "副作用",
        value: "DrugSideEffect",
        class: "text-h7 font-weight-bold lime accent-1",
        width: "200px",
      },
    ],
    footerprops: {
      showFirstLastPage: true,
      itemsPerPageText: "每頁",
      itemsPerPageAllText: "所有",
    },
  }),

  async mounted() {
    this.loading = true;

    await this.getCtrDep();

    var res = await api.DrugInfo({});
    this.drugs = res.data.Data;

    this.loading = false;
  },

  // computed: {
  //   DepCodeIn() {
  //     return this.deps.filter((x) => x.selected).map((x) => x.DepCode);
  //   },
  // },

  watch: {
    // DepCodeIn(val) {
    //   if (val.length > 0) this.getData();
    //   else this.items = [];
    // },
    drug(val) {
      this.depSelect = [];
      this.search = "";

      if (val != null) {
        if (this.depSelect.indexOf(val.CtrCode) == -1)
          this.depSelect.push(val.CtrCode);

        this.search = val.DrugCode;
      }
    },
    depSelect(val) {
      if (val.length > 0) this.getData();
      else this.items = [];
    },
  },

  methods: {
    async getCtrDep() {
      this.loading = true;

      var response = await api.CtrDep({
        DepKind: "Web",
        DepCodeIn: this.$store.state.depsNo,
      });
      // console.log("【:getCtrDep->CtrDep:】", response);

      this.deps = response.data.Data;
      if (this.deps.length == 1) {
        this.deps.forEach((x) => (x.selected = true));
      }

      this.loading = false;
    },
    getData() {
      this.loading = true;
      api
        .DrugInfo({ CtrCodeIn: this.depSelect })
        .then(
          (response) =>
            // console.log("【:getData->DrugInfo:】", response),
            (this.items = response.data.Data)
            //this.items.forEach((x, i) => (x.SerialNumber = i + 1))
        )
        .catch()
        .finally(() => (this.loading = false));
    },

    customFilter(item, queryText) {
      return (
        item.DrugCode.toUpperCase().indexOf(queryText.toUpperCase()) > -1 ||
        item.DrugName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
        item.DrugName2.toLowerCase().indexOf(queryText.toLowerCase()) > -1
      );
    },
    setValue(val) {
      return val;
    },
  },
};
</script>
